<template>
  <div>

    <!--------------------------hamburger menu----------------------------->
    <v-app-bar
            v-if="hamburger_menu"
            :app="app_val"
            id="site-menu"
            elevation="0"
    >
      <!--<a href="/">-->
        <!--<img src="../assets/images/logo/espy-logo-dark-bg.svg" width="200px">-->
      <!--</a>-->

      <!--<span class="pa-3"></span>-->

      <v-spacer></v-spacer>

      <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
                  icon
                  v-on="on"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
          >
            <v-list-item-title>

              <v-btn v-if="item.url" text :to="item.url">{{ item.name }}</v-btn>
              <v-btn v-else text :href="item.href">{{ item.name }}</v-btn>
              </v-list-item-title>
          </v-list-item>


        </v-list>
      </v-menu>
    </v-app-bar>



    <!--------------------------full size menu----------------------------->
    <v-app-bar
            v-else
            :app="app_val"
            id="site-menu"
            elevation="0"
    >
      <div
              v-for="(item, i) in items"
              :key="i">
        <v-btn
                v-if="item.url"
                text
                :to="item.url"
        >
          <span class="black--text">{{ item.name }}</span>
        </v-btn>

        <v-btn
                v-else
                text
                :href="item.href"
        >
          <span class="black--text">{{ item.name }}</span>
        </v-btn>
      </div>


    </v-app-bar>


  </div>

</template>


<style>

  #site-menu{
  background: none;
  }

  .link-active{
    background-color: #2196F3;
  }



</style>
<script>
export default {
  name: 'NavBar',
   props:{
     app: Boolean
   },

  data: () => ({
     show_menu: false,

     items: [
        {name: 'Home', url: '/'},
        {name: 'Services', url: '/services'},
        {name: 'Conditions', url: '/conditions'},
        {name: 'Contact', url: '/contact'},
        {name: 'Patient Forms', href: `${window.location.origin}/forms/better_living_clinic_new_patient.pdf`},

     ]

  }),
   methods:{
      toggle_menu(){
         if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)){
            this.show_menu=false;
            return;
         }

         this.show_menu = !this.show_menu;


      }
   },

   computed:{

     hamburger_menu(){
        return (['xs', 'sm'].includes(this.$vuetify.breakpoint.name));
     },

      app_val()
      {
         if (this.app !== undefined)
            return this.app;
         else return false;
      }
   },

   created(){
     // console.log(this.$vuetify.breakpoint)

     console.log('baseurl', window.location)

   }
};
</script>
